import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "pt-5 flex flex-col" }
const _hoisted_6 = { class: "pt-5 flex flex-col" }
const _hoisted_7 = { class: "pt-5 flex flex-col" }
const _hoisted_8 = { class: "pl-4 list-disc" }
const _hoisted_9 = { class: "pt-5 flex flex-col mb-5" }
const _hoisted_10 = { class: "relative inline-block p-2 group" }
const _hoisted_11 = { class: "mr-2 border border-next p-1" }
const _hoisted_12 = { class: "mr-1" }
const _hoisted_13 = { class: "my-3" }
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "flex justify-end" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = { class: "p-2 bg-next-gray-md-dark hover:bg-white w-full" }
const _hoisted_28 = { class: "flex flex-col" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = { class: "flex justify-end" }
const _hoisted_32 = { class: "flex pt-3 justify-between" }
const _hoisted_33 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_ModalInput = _resolveComponent("ModalInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { id: "selectModal" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Dettaglio utente ", -1)),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass([[_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'], "text-white p-3 mb-3 flex justify-between items-center"])
        }, [
          _createTextVNode(_toDisplayString(_ctx.response_message) + " ", 1),
          _createElementVNode("i", {
            class: "icon-x cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.response_message = ''))
          })
        ], 2), [
          [_vShow, _ctx.response_message.length]
        ]),
        _createElementVNode("p", null, [
          _cache[5] || (_cache[5] = _createTextVNode("Nome utente: ")),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.utente.name), 1)
        ]),
        _createElementVNode("p", null, [
          _cache[6] || (_cache[6] = _createTextVNode("Email: ")),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.utente.email), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, { field_name: "Gruppi" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.gruppiAutcomplete.selection,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gruppiAutcomplete.selection) = $event)),
                options: _ctx.gruppiAutcomplete.options,
                placeholder: "Gruppi",
                class: "next-vue-multiselect",
                "track-by": "id",
                label: "name",
                multiple: true,
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": false,
                onSearchChange: _ctx.gruppiAutcomplete.search
              }, {
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, { field_name: "Permessi" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.permessiAutcomplete.selection,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.permessiAutcomplete.selection) = $event)),
                options: _ctx.permessiAutcomplete.options,
                placeholder: "Permessi",
                class: "next-vue-multiselect",
                "track-by": "id",
                label: "name",
                multiple: true,
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": false,
                "close-on-select": false,
                onSearchChange: _ctx.permessiAutcomplete.search
              }, {
                tag: _withCtx(({option, remove}) => [
                  _createVNode(_component_MultiselectOption, {
                    onRemove: ($event: any) => (remove(option))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Field, { field_name: "Utente responsabile" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.userAutocomplete.selection,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userAutocomplete.selection) = $event)),
                options: _ctx.userAutocomplete.options,
                placeholder: "Utente controllore",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "name",
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": false,
                onSearchChange: _ctx.userAutocomplete.search
              }, null, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "Questo utente è responsabile di:", -1)),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responsabileDi, (r) => {
              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(r.name), 1))
            }), 256))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Field, { field_name: "Business unit" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                searchable: true,
                loading: _ctx.buAutocomplete.isLoading,
                "internal-search": false,
                trackBy: "id",
                label: "nome",
                onSearchChange: _ctx.buAutocomplete.search,
                modelValue: _ctx.buAutocomplete.selection,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
                options: _ctx.buAutocomplete.options,
                "close-on-select": true,
                "clear-on-select": true,
                class: "next-vue-multiselect-single",
                placeholder: "Business Unit",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                option: _withCtx(({option, props}) => [
                  _createElementVNode("span", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(option.label), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(option.nome), 1)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "onSearchChange", "modelValue", "options"])
            ]),
            _: 1
          })
        ]),
        (_ctx.errors['ore']?.length)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              class: "bg-next-orange"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.errors['ore'][0]), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"font-bold pb-2 text-sm\">Ora lavorative</div><div class=\"grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4\"><p class=\"font-bold pb-2 text-sm\">Dal</p><p class=\"font-bold pb-2 text-sm\">Al</p><p class=\"font-bold pb-2 text-sm\">Ore</p><p class=\"w-8\"> </p></div>", 2)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ore, (ora, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3"
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Field, {
                  "label-visible": false,
                  errors: _ctx.getErrors(i,'ore', 'data_inizio')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((ora.data_inizio) = $event),
                      type: "date",
                      class: "p-7px bg-next-gray-md-dark hover:bg-white"
                    }, null, 8, _hoisted_15), [
                      [_vModelText, ora.data_inizio]
                    ])
                  ]),
                  _: 2
                }, 1032, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Field, {
                  "label-visible": false,
                  errors: _ctx.getErrors(i,'ore', 'data_fine')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((ora.data_fine) = $event),
                      type: "date",
                      class: "p-7px bg-next-gray-md-dark hover:bg-white"
                    }, null, 8, _hoisted_17), [
                      [_vModelText, ora.data_fine]
                    ])
                  ]),
                  _: 2
                }, 1032, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Field, {
                  "label-visible": false,
                  errors: _ctx.getErrors(i,'ore', 'ore')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((ora.ore) = $event),
                      type: "number",
                      step: "1",
                      class: "p-7px bg-next-gray-md-dark hover:bg-white"
                    }, null, 8, _hoisted_19), [
                      [_vModelText, ora.ore]
                    ])
                  ]),
                  _: 2
                }, 1032, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_NextButton, {
                  variant: "outline-secondary",
                  onClick: ($event: any) => (_ctx.removeOre(i)),
                  class: "col flex justify-center items-center h-8 w-8"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createElementVNode("i", { class: "icon-x" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.addOre,
            class: "col flex justify-center items-center h-8 w-8"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        (_ctx.hasPermission('can_import_costi_timesheet'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.errors['bu_costi']?.length)
                ? (_openBlock(), _createBlock(_component_Alert, {
                    key: 0,
                    class: "bg-next-orange my-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.errors['bu_costi'][0]), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"font-bold pb-2 text-sm\">Costi utente per business unit</div><div class=\"grid grid-cols-[repeat(4,_minmax(0,_1fr))_max-content] gap-4\"><p class=\"font-bold pb-2 text-sm\">Dal</p><p class=\"font-bold pb-2 text-sm\">Al</p><p class=\"font-bold pb-2 text-sm\">Business unit</p><p class=\"font-bold pb-2 text-sm\">Costo</p><p class=\"w-8\"> </p></div>", 2)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bu_costi, (bu_costo, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "grid grid-cols-[repeat(4,_minmax(0,_1fr))_max-content] gap-4 mb-3"
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Field, {
                      "label-visible": false,
                      errors: _ctx.getErrors(i,'bu_costi', 'data_inizio')
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((bu_costo.data_inizio) = $event),
                          type: "date",
                          class: "p-7px bg-next-gray-md-dark hover:bg-white"
                        }, null, 8, _hoisted_23), [
                          [_vModelText, bu_costo.data_inizio]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["errors"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      "label-visible": false,
                      errors: _ctx.getErrors(i,'bu_costi', 'data_fine')
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((bu_costo.data_fine) = $event),
                          type: "date",
                          class: "p-7px bg-next-gray-md-dark hover:bg-white"
                        }, null, 8, _hoisted_25), [
                          [_vModelText, bu_costo.data_fine]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["errors"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Field, {
                      "label-visible": false,
                      errors: _ctx.getErrors(i,'bu_costi', 'business_unit_id')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ModalInput, {
                          autocomplete: _ctx.buCostiAutocomplete,
                          onConfirm: ($event: any) => (bu_costo.business_unit = $event),
                          "track-by": "id",
                          label: "nome",
                          class: "next-vue-multiselect-single"
                        }, {
                          cell: _withCtx((option) => [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(bu_costo?.business_unit?.nome || 'Scegli una BU'), 1)
                          ]),
                          _: 2
                        }, 1032, ["autocomplete", "onConfirm"])
                      ]),
                      _: 2
                    }, 1032, ["errors"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_Field, {
                      "label-visible": false,
                      errors: _ctx.getErrors(i,'bu_costi', 'costo_orario')
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((bu_costo.costo_orario) = $event),
                          type: "number",
                          step: "0.01",
                          class: "p-7px bg-next-gray-md-dark hover:bg-white"
                        }, null, 8, _hoisted_29), [
                          [_vModelText, bu_costo.costo_orario]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["errors"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_NextButton, {
                      variant: "outline-secondary",
                      onClick: ($event: any) => (_ctx.remove(i)),
                      class: "col flex justify-center items-center h-8 w-8"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "icon-x" }, null, -1)
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_NextButton, {
                  variant: "primary",
                  onClick: _ctx.add,
                  class: "col flex justify-center items-center h-8 w-8"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "icon-croce_quadrata" }, null, -1)
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
          (_ctx.hasPermission('delete users'))
            ? (_openBlock(), _createBlock(_component_NextButton, {
                key: 0,
                class: "px-3 py-2",
                onClick: _ctx.toggleCancella
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isDeleted ? 'Riabilita utente' : 'Cancella utente'), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_33)),
          _createVNode(_component_NextButton, {
            class: "px-3 py-2",
            onClick: _ctx.save
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("Salva")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ], 64))
}